import React from "react";
import styled from "styled-components";

export function ObjectiveAdder({
  show,
  objectives,
  onObjectivesChanged,
  selectedObjectives,
}) {
  const onSelected = (objective) => {
    const newSelection = [...selectedObjectives, objective];
    onObjectivesChanged(newSelection);
  };
  return (
    <React.Fragment>
      {show && (
        <ObjectiveAdderPanel>
          <h3>Objectives:</h3>
          {objectives
            .filter((x) => !selectedObjectives.includes(x))
            .map((x, i) => (
              <ObjectiveItem
                key={i}
                onClick={(e) => {
                  e.stopPropagation();
                  onSelected(x);
                }}
              >
                {x}
              </ObjectiveItem>
            ))}
        </ObjectiveAdderPanel>
      )}
    </React.Fragment>
  );
}
const ObjectiveItem = styled.div`
  padding-left: 5px;
  padding-right: 5px;
  :hover& {
    background: #5181ac;
  }
`;

export const ObjectiveAdderPanel = styled.div`
  border: 1px solid #5181ac;
  z-index: 5;
  position: absolute;
  background: #282c34;
`;
